(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7345],{

/***/ 73238:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "At": function() { return /* binding */ BreadcrumbLink; },
/* harmony export */   "aG": function() { return /* binding */ Breadcrumb; },
/* harmony export */   "gN": function() { return /* binding */ BreadcrumbItem; }
/* harmony export */ });
/* unused harmony exports BreadcrumbSeparator, useBreadcrumbStyles */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _chakra_ui_react_children_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(34031);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(15818);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(54520);
/* harmony import */ var _chakra_ui_react_context__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(28387);
// ../../../react-shim.js


// ../../utilities/shared-utils/src/index.ts
var cx = (...classNames) => classNames.filter(Boolean).join(" ");

// src/breadcrumb.tsx




// src/breadcrumb-context.ts

var [BreadcrumbStylesProvider, useBreadcrumbStyles] = (0,_chakra_ui_react_context__WEBPACK_IMPORTED_MODULE_1__/* .createContext */ .k)({
  name: `BreadcrumbStylesContext`,
  errorMessage: `useBreadcrumbStyles returned is 'undefined'. Seems you forgot to wrap the components in "<Breadcrumb />" `
});

// src/breadcrumb.tsx
var Breadcrumb = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .forwardRef */ .Gp)(function Breadcrumb2(props, ref) {
  const styles = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .useMultiStyleConfig */ .jC)("Breadcrumb", props);
  const ownProps = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_3__/* .omitThemingProps */ .Lr)(props);
  const {
    children,
    spacing = "0.5rem",
    separator = "/",
    className,
    listProps,
    ...rest
  } = ownProps;
  const validChildren = (0,_chakra_ui_react_children_utils__WEBPACK_IMPORTED_MODULE_4__/* .getValidChildren */ .W)(children);
  const count = validChildren.length;
  const clones = validChildren.map((child, index) => (0,react__WEBPACK_IMPORTED_MODULE_0__.cloneElement)(child, {
    separator,
    spacing,
    isLastChild: count === index + 1
  }));
  const _className = cx("chakra-breadcrumb", className);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .chakra.nav */ .m$.nav, {
    ref,
    "aria-label": "breadcrumb",
    className: _className,
    __css: styles.container,
    ...rest
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(BreadcrumbStylesProvider, {
    value: styles
  }, /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .chakra.ol */ .m$.ol, {
    className: "chakra-breadcrumb__list",
    ...listProps,
    __css: {
      display: "flex",
      alignItems: "center",
      ...styles.list
    }
  }, clones)));
});
Breadcrumb.displayName = "Breadcrumb";

// src/breadcrumb-item.tsx



// src/breadcrumb-separator.tsx

var BreadcrumbSeparator = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .forwardRef */ .Gp)(function BreadcrumbSeparator2(props, ref) {
  const { spacing, ...rest } = props;
  const styles = useBreadcrumbStyles();
  const separatorStyles = {
    mx: spacing,
    ...styles.separator
  };
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .chakra.span */ .m$.span, {
    ref,
    role: "presentation",
    ...rest,
    __css: separatorStyles
  });
});
BreadcrumbSeparator.displayName = "BreadcrumbSeparator";

// src/breadcrumb-link.tsx

var BreadcrumbLink = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .forwardRef */ .Gp)(function BreadcrumbLink2(props, ref) {
  const { isCurrentPage, as, className, href, ...rest } = props;
  const styles = useBreadcrumbStyles();
  const sharedProps = {
    ref,
    as,
    className: cx("chakra-breadcrumb__link", className),
    ...rest
  };
  if (isCurrentPage) {
    return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .chakra.span */ .m$.span, {
      "aria-current": "page",
      __css: styles.link,
      ...sharedProps
    });
  }
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .chakra.a */ .m$.a, {
    __css: styles.link,
    href,
    ...sharedProps
  });
});
BreadcrumbLink.displayName = "BreadcrumbLink";

// src/breadcrumb-item.tsx

var BreadcrumbItem = (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .forwardRef */ .Gp)(function BreadcrumbItem2(props, ref) {
  const {
    isCurrentPage,
    separator,
    isLastChild,
    spacing,
    children,
    className,
    ...rest
  } = props;
  const validChildren = (0,_chakra_ui_react_children_utils__WEBPACK_IMPORTED_MODULE_4__/* .getValidChildren */ .W)(children);
  const clones = validChildren.map((child) => {
    if (child.type === BreadcrumbLink) {
      return (0,react__WEBPACK_IMPORTED_MODULE_0__.cloneElement)(child, {
        isCurrentPage
      });
    }
    if (child.type === BreadcrumbSeparator) {
      return (0,react__WEBPACK_IMPORTED_MODULE_0__.cloneElement)(child, {
        spacing,
        children: child.props.children || separator
      });
    }
    return child;
  });
  const styles = useBreadcrumbStyles();
  const itemStyles = {
    display: "inline-flex",
    alignItems: "center",
    ...styles.item
  };
  const _className = cx("chakra-breadcrumb__list-item", className);
  return /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(_chakra_ui_system__WEBPACK_IMPORTED_MODULE_2__/* .chakra.li */ .m$.li, {
    ref,
    className: _className,
    ...rest,
    __css: itemStyles
  }, clones, !isLastChild && /* @__PURE__ */ react__WEBPACK_IMPORTED_MODULE_0__.createElement(BreadcrumbSeparator, {
    spacing
  }, separator));
});
BreadcrumbItem.displayName = "BreadcrumbItem";



/***/ }),

/***/ 74918:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/products",
      function () {
        return __webpack_require__(84860);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 64070:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ page_header_PageHeader; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js
var index_esm = __webpack_require__(48641);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/breadcrumb/dist/index.esm.js
var dist_index_esm = __webpack_require__(73238);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./components/breadcrumb/AppBreadcrumb.tsx





function AppBreadcrumb(param) {
    let { breadcrumb  } = param;
    // use router
    const { pathname  } = (0,router.useRouter)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* Breadcrumb */.aG, {
            separator: ">",
            color: "gray.600",
            className: "app-breadcrumb",
            children: breadcrumb.map((item, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* BreadcrumbItem */.gN, {
                    isCurrentPage: pathname === item.href,
                    children: item.href ? /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                        href: item.href,
                        passHref: true,
                        legacyBehavior: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(dist_index_esm/* BreadcrumbLink */.At, {
                            children: item.label
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Text */.xv, {
                        noOfLines: 1,
                        children: item.label
                    })
                }, index))
        })
    });
}
/* harmony default export */ var breadcrumb_AppBreadcrumb = (AppBreadcrumb);

;// CONCATENATED MODULE: ./components/page-header/PageHeader.tsx




function PageHeader(param) {
    let { title , breadcrumb , backLink , containerMaxWidth ="850px"  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                borderBottom: "1px solid",
                borderColor: "primary.400",
                pt: 8,
                pb: 4,
                bgGradient: "linear(to-t, white 55%, #ffd5b1 100%)",
                display: {
                    base: "none",
                    lg: "block"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Container */.W2, {
                    maxWidth: containerMaxWidth,
                    children: [
                        title && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
                            color: "gray.600",
                            fontWeight: "300",
                            fontSize: "lg",
                            children: title
                        }),
                        breadcrumb && breadcrumb.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                            fontSize: "lg",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(breadcrumb_AppBreadcrumb, {
                                breadcrumb: breadcrumb
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Box */.xu, {
                py: 2,
                display: {
                    base: "block",
                    lg: "none"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(index_esm/* Container */.W2, {
                    children: [
                        title && /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* Heading */.X6, {
                            color: "gray.600",
                            fontWeight: "300",
                            fontSize: "md",
                            children: title
                        }),
                        breadcrumb && breadcrumb.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(breadcrumb_AppBreadcrumb, {
                            breadcrumb: breadcrumb
                        })
                    ]
                })
            })
        ]
    });
}
/* harmony default export */ var page_header_PageHeader = (PageHeader);


/***/ }),

/***/ 61053:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(48641);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(47741);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);





function PageTitleMobile(param) {
    let { children , backLink  } = param;
    // use router
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_2__.useRouter)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Box */ .xu, {
        bg: "#F36621",
        height: "32px",
        display: {
            lg: "none"
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Container */ .W2, {
            h: "100%",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .HStack */ .Ug, {
                color: "white",
                h: "100%",
                children: [
                    backLink && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_5__/* .Button */ .zx, {
                        variant: "unstyled",
                        minW: "auto",
                        minHeight: "auto",
                        onClick: ()=>{
                            router.push(backLink, backLink, {
                                locale: router.locale
                            });
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                            src: "/image-icon/arrow-prev-white.png",
                            width: 9,
                            height: 12,
                            alt: "next"
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Heading */ .X6, {
                        fontSize: "17px",
                        fontWeight: "400",
                        color: "white",
                        children: children
                    })
                ]
            })
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (PageTitleMobile);


/***/ }),

/***/ 21572:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);



function ProductBadge(param) {
    let { type ="special-price" , imageName  } = param;
    const badge = {
        "special-price": {
            src: "/badge/special-price.png",
            alt: "sale"
        },
        new: {
            src: "/badge/new-arrival.png",
            alt: "new"
        },
        "best-seller": {
            src: "/badge/bestseller.png",
            alt: "best-seller"
        },
        "1get1": {
            src: "/badge/1get1.png",
            alt: "1get1"
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        children: imageName ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
            src: "".concat("https://storage.lamptan.co.th", "/").concat(imageName),
            alt: imageName,
            width: 50,
            height: 50
        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
            src: badge[type].src,
            alt: badge[type].alt,
            width: 50,
            height: 50
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (ProductBadge);


/***/ }),

/***/ 10829:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(48641);
/* harmony import */ var components_utils_UtilPriceFormatter__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74046);
/* harmony import */ var hooks_useProductItem__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(13043);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react_equal_height_clean__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(64400);
/* harmony import */ var react_equal_height_clean__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(react_equal_height_clean__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _ProductBadge__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(21572);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_7__);









function ProductItem(param) {
    let { product  } = param;
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_7__.useRouter)();
    const { locale  } = router;
    const { featuredImage , salePrice , savingPrice , regularPrice  } = (0,hooks_useProductItem__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        product
    });
    var _product_productBadge_imageName;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .Box */ .xu, {
        height: "100%",
        _hover: {
            boxShadow: "0 0 6px #fdb869",
            transition: "all 0.2s ease"
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_4___default()), {
            href: "\n              /products/".concat(product === null || product === void 0 ? void 0 : product.permalink, "\n            "),
            passHref: true,
            legacyBehavior: true,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .Link */ .rU, {
                height: "100%",
                textDecoration: "none !important",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .Flex */ .kC, {
                    height: "100%",
                    flexDirection: "column",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .Box */ .xu, {
                            position: "relative",
                            children: [
                                product.productBadge ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .Center */ .M5, {
                                    position: "absolute",
                                    top: "0",
                                    left: 3,
                                    zIndex: "docked",
                                    px: 1,
                                    minH: "44.1px",
                                    borderBottomRadius: "4px",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ProductBadge__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                        imageName: (_product_productBadge_imageName = product.productBadge.imageName) !== null && _product_productBadge_imageName !== void 0 ? _product_productBadge_imageName : ""
                                    })
                                }) : product.isNewArrival ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .Center */ .M5, {
                                    position: "absolute",
                                    top: "0",
                                    left: 3,
                                    zIndex: "docked",
                                    px: 1,
                                    minH: "44.1px",
                                    borderBottomRadius: "4px",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ProductBadge__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                        type: "new"
                                    })
                                }) : product.isBestSeller ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .Center */ .M5, {
                                    position: "absolute",
                                    top: "0",
                                    left: 3,
                                    zIndex: "docked",
                                    px: 1,
                                    minH: "44.1px",
                                    borderBottomRadius: "4px",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ProductBadge__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                        type: "best-seller"
                                    })
                                }) : product.isOnSale ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .Center */ .M5, {
                                    position: "absolute",
                                    top: "0",
                                    left: 3,
                                    zIndex: "docked",
                                    px: 1,
                                    minH: "44.1px",
                                    borderBottomRadius: "4px",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ProductBadge__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                        type: "special-price"
                                    })
                                }) : null,
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .AspectRatio */ .oM, {
                                    ratio: 1,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_3___default()), {
                                        src: "".concat(featuredImage),
                                        width: 500,
                                        height: 500,
                                        alt: product.name_en
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .Flex */ .kC, {
                            bg: "#EADECE",
                            py: 2,
                            px: 3,
                            flex: 1,
                            flexDirection: "column",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_equal_height_clean__WEBPACK_IMPORTED_MODULE_5__.EqualHeightElement, {
                                    name: "title",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .Heading */ .X6, {
                                        fontWeight: "300",
                                        textTransform: "uppercase",
                                        fontSize: "14px",
                                        as: "h5",
                                        noOfLines: 3,
                                        flex: 1,
                                        children: locale === "th" ? product.name_th : product.name_en
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .Flex */ .kC, {
                                    justifyContent: "flex-end",
                                    borderTop: "1px solid",
                                    borderColor: "gray.400",
                                    mt: 2,
                                    pt: 1,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .Box */ .xu, {
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .HStack */ .Ug, {
                                                justifyContent: "flex-end",
                                                alignItems: "flex-end",
                                                spacing: 1,
                                                children: salePrice > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                                    children: [
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .Text */ .xv, {
                                                            fontSize: "xs",
                                                            pt: 1,
                                                            as: "s",
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_utils_UtilPriceFormatter__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                                                price: regularPrice,
                                                                format: "0,0"
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .Text */ .xv, {
                                                            color: "primary.500",
                                                            fontSize: "2xl",
                                                            lineHeight: 1.05,
                                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_utils_UtilPriceFormatter__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                                                price: salePrice,
                                                                format: "0,0"
                                                            })
                                                        })
                                                    ]
                                                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                                                    children: regularPrice > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .Text */ .xv, {
                                                        color: "primary.500",
                                                        fontSize: "2xl",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_utils_UtilPriceFormatter__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                                            price: regularPrice,
                                                            format: "0,0"
                                                        })
                                                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .Text */ .xv, {
                                                        children: "N/A"
                                                    })
                                                })
                                            }),
                                            savingPrice > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .HStack */ .Ug, {
                                                justifyContent: "flex-end",
                                                mt: 1.5,
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_8__/* .Box */ .xu, {
                                                    fontSize: "xs",
                                                    textTransform: "uppercase",
                                                    bg: "#eb4123",
                                                    flex: "0 0 auto",
                                                    px: 2,
                                                    color: "white",
                                                    children: [
                                                        "Save",
                                                        " ",
                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_utils_UtilPriceFormatter__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                                            price: savingPrice,
                                                            format: "0,0"
                                                        })
                                                    ]
                                                })
                                            }) : null
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (ProductItem);


/***/ }),

/***/ 90278:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var hooks_useProducts__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7980);
/* harmony import */ var _ProductItem__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(10829);
/* harmony import */ var react_equal_height_clean__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(64400);
/* harmony import */ var react_equal_height_clean__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(react_equal_height_clean__WEBPACK_IMPORTED_MODULE_3__);




function ProductList(param) {
    let { query  } = param;
    const { products  } = (0,hooks_useProducts__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(query);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_equal_height_clean__WEBPACK_IMPORTED_MODULE_3__.EqualHeight, {
        children: products === null || products === void 0 ? void 0 : products.map((product)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_ProductItem__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                product: product
            }, product.id))
    });
}
/* harmony default export */ __webpack_exports__["Z"] = (ProductList);


/***/ }),

/***/ 7980:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useProducts; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var swr__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8100);


function useProducts(queryStringify) {
    const [products, setProducts] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)([]);
    const [isLoading, setIsLoading] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(true);
    const { data: productData , error , isValidating  } = (0,swr__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP)(queryStringify ? "".concat("https://api.lamptan.co.th", "/v1/public/products?").concat(queryStringify) : null);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        if (productData) {
            setProducts(productData.docs);
            setIsLoading(false);
        } else {
            setIsLoading(true);
        }
    }, [
        productData
    ]);
    return {
        productData,
        products: products,
        isProductsLoading: !error && !productData,
        isValidating
    };
}


/***/ }),

/***/ 84860:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96486);
/* harmony import */ var lodash__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(lodash__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var swr__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(8100);
/* harmony import */ var query_string__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(17563);
/* harmony import */ var components_products_ProductList__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(90278);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(51469);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(48641);
/* harmony import */ var layouts_RootLayout__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(89806);
/* harmony import */ var components_page_header_PageHeader__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(64070);
/* harmony import */ var components_page_header_PageTitleMobile__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(61053);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(31567);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var hooks_useProducts__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(7980);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(28809);














const ProductsPage = ()=>{
    const { t  } = (0,react_i18next__WEBPACK_IMPORTED_MODULE_11__/* .useTranslation */ .$)([
        "product",
        "common"
    ]);
    // use router
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_9__.useRouter)();
    // use media query
    const [isTablet] = (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_12__/* .useMediaQuery */ .ac)("(min-width: 768px)");
    const [isDesktop] = (0,_chakra_ui_react__WEBPACK_IMPORTED_MODULE_12__/* .useMediaQuery */ .ac)("(min-width: 992px)");
    // get query from url
    const { query  } = router;
    // get paage
    const { data: pageHomeData  } = (0,swr__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)("".concat("https://api.lamptan.co.th", "/v1/pages/permalink/home"));
    // init product new arrival query string
    const [productQueryString, setProductQueryString] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)("");
    const { productData , isProductsLoading  } = (0,hooks_useProducts__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z)(productQueryString);
    // page title
    const pageTitle = query.type ? query.type === "new-arrival" ? t("สินค้าใหม่") : query.type === "best-seller" ? t("สินค้าขายดี") : query.type === "spacial-price" ? t("สินค้าราคาพิเศษ") : "" : "";
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(()=>{
        if (pageHomeData) {
            if (pageHomeData.customFields) {
                if (query.type) {
                    if (query.type === "new-arrival") {
                        // ********** Product new arrival **********
                        const newArrivalProducts = pageHomeData.customFields.find((field)=>field.key === "newArrivalProducts");
                        if (newArrivalProducts && !(0,lodash__WEBPACK_IMPORTED_MODULE_1__.isEmpty)(newArrivalProducts)) {
                            const newArrivalProductsValue = JSON.parse(newArrivalProducts.value);
                            ;
                            setProductQueryString(query_string__WEBPACK_IMPORTED_MODULE_4__.stringify({
                                ids: newArrivalProductsValue.join(","),
                                page: 1,
                                limit: isDesktop ? 25 : isTablet ? 24 : 24
                            }));
                        }
                    } else if (query.type === "best-seller") {
                        // ********** Product best seller **********
                        const bestSellerProducts = pageHomeData.customFields.find((field)=>field.key === "bestSellerProducts");
                        if (bestSellerProducts && !(0,lodash__WEBPACK_IMPORTED_MODULE_1__.isEmpty)(bestSellerProducts)) {
                            const bestSellerProductsValue = JSON.parse(bestSellerProducts.value);
                            ;
                            setProductQueryString(query_string__WEBPACK_IMPORTED_MODULE_4__.stringify({
                                ids: bestSellerProductsValue.join(","),
                                page: 1,
                                limit: isDesktop ? 25 : isTablet ? 24 : 24
                            }));
                        }
                    } else if (query.type === "spacial-price") {
                        // ********** Product spacial price **********
                        const spacialPriceProducts = pageHomeData.customFields.find((field)=>field.key === "spacialProducts");
                        if (spacialPriceProducts && !(0,lodash__WEBPACK_IMPORTED_MODULE_1__.isEmpty)(spacialPriceProducts)) {
                            const spacialPriceProductsValue = JSON.parse(spacialPriceProducts.value);
                            ;
                            setProductQueryString(query_string__WEBPACK_IMPORTED_MODULE_4__.stringify({
                                ids: spacialPriceProductsValue.join(","),
                                page: 1,
                                limit: isDesktop ? 25 : isTablet ? 24 : 24
                            }));
                        }
                    }
                }
            }
        }
    }, [
        pageHomeData,
        query,
        isDesktop,
        isTablet
    ]);
    ;
    // handle pagination change
    const handlePaginationChange = (page)=>{
        const queryParsedUrl = query_string__WEBPACK_IMPORTED_MODULE_4__.parseUrl(window.location.href);
        const queryParsed = query_string__WEBPACK_IMPORTED_MODULE_4__.parse(productQueryString);
        ;
        const { query  } = queryParsed;
        ;
        const queryFormatted = {
            ...queryParsed,
            page: page
        };
        ;
        // format query string
        const queryStringFormatted = query_string__WEBPACK_IMPORTED_MODULE_4__.stringify(queryFormatted);
        setProductQueryString(queryStringFormatted);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_page_header_PageHeader__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                title: pageTitle
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_page_header_PageTitleMobile__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                children: pageTitle
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_13__/* .Container */ .W2, {
                py: 10,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_13__/* .SimpleGrid */ .MI, {
                        columns: {
                            base: 2,
                            md: 3,
                            lg: 4,
                            xl: 5
                        },
                        gap: 6,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_products_ProductList__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                            query: productQueryString
                        })
                    }),
                    productData && (productData === null || productData === void 0 ? void 0 : productData.totalPages) > 1 && !isProductsLoading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_13__/* .Center */ .M5, {
                        mt: 10,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(antd__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                            defaultCurrent: 1,
                            current: productData.page,
                            pageSize: isDesktop ? 25 : isTablet ? 24 : 14,
                            total: productData.totalDocs,
                            defaultPageSize: isDesktop ? 25 : isTablet ? 24 : 14,
                            showLessItems: true,
                            showSizeChanger: false,
                            onChange: handlePaginationChange,
                            className: "custom-product-archive-pagination"
                        })
                    })
                ]
            })
        ]
    });
};
ProductsPage.getLayout = (page)=>{
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(layouts_RootLayout__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        children: page
    });
};
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (ProductsPage);


/***/ }),

/***/ 64400:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

(()=>{var e={318:e=>{e.exports=function(e){return e&&e.__esModule?e:{default:e}},e.exports.default=e.exports,e.exports.__esModule=!0},8:e=>{function t(n){return"function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?(e.exports=t=function(e){return typeof e},e.exports.default=e.exports,e.exports.__esModule=!0):(e.exports=t=function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},e.exports.default=e.exports,e.exports.__esModule=!0),t(n)}e.exports=t,e.exports.default=e.exports,e.exports.__esModule=!0},149:(e,t,n)=>{"use strict";var r=function(){return r=Object.assign||function(e){for(var t,n=1,r=arguments.length;n<r;n++)for(var o in t=arguments[n])Object.prototype.hasOwnProperty.call(t,o)&&(e[o]=t[o]);return e},r.apply(this,arguments)};Object.defineProperty(t,"__esModule",{value:!0}),t.EqualHeightConsumer=t.EqualHeightProvider=t.EqualHeightContext=void 0;var o,u=(o=n(689))&&o.__esModule?o:{default:o},i=n(32),a=r({setTemporarySizes:function(){},setOriginalChildrenCount:function(){},setChildrenCount:function(){},setForceUpdate:function(){}},i.defaults),l=u.default.createContext({sizes:a&&a.sizes,temporarySizes:a&&a.temporarySizes,update:a&&a.update,animationSpeed:a&&a.animationSpeed,forceUpdate:a&&a.forceUpdate,originalChildrenCount:a&&a.originalChildrenCount,childrenCount:a&&a.childrenCount,setTemporarySizes:a&&a.setTemporarySizes,setOriginalChildrenCount:a&&a.setOriginalChildrenCount,setChildrenCount:a&&a.setChildrenCount,setForceUpdate:a&&a.setForceUpdate,updateOnChange:a&&a.updateOnChange});t.EqualHeightContext=l;var d=l.Provider;t.EqualHeightProvider=d;var s=l.Consumer;t.EqualHeightConsumer=s},899:(e,t,n)=>{"use strict";var r=Object.create?function(e,t,n,r){void 0===r&&(r=n),Object.defineProperty(e,r,{enumerable:!0,get:function(){return t[n]}})}:function(e,t,n,r){void 0===r&&(r=n),e[r]=t[n]},o=Object.create?function(e,t){Object.defineProperty(e,"default",{enumerable:!0,value:t})}:function(e,t){e.default=t},u=function(e,t,n){if(n||2===arguments.length)for(var r,o=0,u=t.length;o<u;o++)!r&&o in t||(r||(r=Array.prototype.slice.call(t,0,o)),r[o]=t[o]);return e.concat(r||Array.prototype.slice.call(t))};Object.defineProperty(t,"__esModule",{value:!0});var i,a=function(e){if(e&&e.__esModule)return e;var t={};if(null!=e)for(var n in e)"default"!==n&&Object.prototype.hasOwnProperty.call(e,n)&&r(t,e,n);return o(t,e),t}(n(689)),l=n(149),d=(i=n(136))&&i.__esModule?i:{default:i},s=(0,a.memo)((function(e){var t=e.children,n=void 0===t?"":t,r=e.name,o=e.tag,i=void 0===o?"div":o,s=e.placeholder,f=void 0!==s&&s,c=e.disable,p=void 0!==c&&c,h=(0,a.useContext)(l.EqualHeightContext),m=h.sizes,v=h.update,g=h.setTemporarySizes,y=h.setOriginalChildrenCount,C=h.setChildrenCount,b=h.animationSpeed,O=(0,a.useState)(),S=O[0],x=O[1],E=(0,a.useRef)(null);(0,a.useEffect)((function(){if(!p)return y((function(e){return e+1})),function(){y((function(e){return e-1}))}}),[p,f]),(0,a.useEffect)((function(){p||function(){if(E.current&&!p){var e=E.current.style.getPropertyValue("height");E.current.style.removeProperty("height");var t=E.current.offsetHeight;E.current.style.setProperty("height",e),g((function(e){return u(u([],e,!0),[{name:r,height:t}],!1)})),p||C((function(e){return e+1}))}}()}),[v,p,f]),(0,a.useMemo)((function(){if(!p){var e=m.findIndex((function(e){return e.name===r}));m&&m[e]&&m[e].height&&x(m[e].height)}}),[m]);var P={height:S+"px",transitionDuration:0===b?"":b+"s"};return f||n?a.default.createElement(a.default.Fragment,null,p?n:a.default.createElement(i,{ref:E,className:d.default.wrapper,style:P},!f&&n)):null}));t.default=s},32:(e,t,n)=>{"use strict";var r=n(318)(n(8)),o=Object.create?function(e,t,n,r){void 0===r&&(r=n),Object.defineProperty(e,r,{enumerable:!0,get:function(){return t[n]}})}:function(e,t,n,r){void 0===r&&(r=n),e[r]=t[n]},u=Object.create?function(e,t){Object.defineProperty(e,"default",{enumerable:!0,value:t})}:function(e,t){e.default=t},i=function(e,t,n){if(n||2===arguments.length)for(var r,o=0,u=t.length;o<u;o++)!r&&o in t||(r||(r=Array.prototype.slice.call(t,0,o)),r[o]=t[o]);return e.concat(r||Array.prototype.slice.call(t))};Object.defineProperty(t,"__esModule",{value:!0}),t.defaults=void 0;var a=function(e){if(e&&e.__esModule)return e;var t={};if(null!=e)for(var n in e)"default"!==n&&Object.prototype.hasOwnProperty.call(e,n)&&o(t,e,n);return u(t,e),t}(n(689)),l=n(149);t.defaults={sizes:[],temporarySizes:[],update:!1,forceUpdate:!1,originalChildrenCount:0,childrenCount:0,animationSpeed:.25,timeout:200,updateOnChange:void 0};var d=(0,a.memo)((function(e){var n=e.children,o=e.timeout,u=void 0===o?t.defaults.timeout:o,d=e.animationSpeed,s=void 0===d?t.defaults.animationSpeed:d,f=e.updateOnChange,c=void 0===f?t.defaults.updateOnChange:f,p=(0,a.useState)(t.defaults.sizes),h=p[0],m=p[1],v=(0,a.useState)(t.defaults.temporarySizes),g=v[0],y=v[1],C=(0,a.useState)(t.defaults.update),b=C[0],O=C[1],S=(0,a.useState)(t.defaults.forceUpdate),x=S[0],E=S[1],P=(0,a.useState)(t.defaults.originalChildrenCount),_=P[0],j=P[1],w=(0,a.useState)(t.defaults.childrenCount),q=w[0],H=w[1],M=(0,a.useCallback)((function(){return O((function(e){return!e}))}),[]);return(0,a.useEffect)((function(){var e,t;if("object"===("undefined"==typeof window?"undefined":(0,r.default)(window))&&"object"===(0,r.default)(window.document))return window.addEventListener("resize",u?function(){clearTimeout(e),e=window.setTimeout(M,u)}:M),window.addEventListener("orientationchange",u?function(){clearTimeout(t),t=window.setTimeout(M,u)}:M),function(){window.removeEventListener("resize",M),window.removeEventListener("orientationchange",M)}}),[]),(0,a.useMemo)((function(){M()}),[x,_,c]),(0,a.useMemo)((function(){if(_<=q){var e=[];g.map((function(t){var n=t.name,r=t.height,o=e.findIndex((function(e){return e.name===n}));o>-1?e[o].height<r&&(e[o].height=r):e=i(i([],e,!0),[{name:n,height:r}],!1)})),m(e),y([]),H(0)}}),[q]),a.default.createElement(l.EqualHeightProvider,{value:{sizes:h,temporarySizes:g,update:b,animationSpeed:s,forceUpdate:x,originalChildrenCount:_,childrenCount:q,setTemporarySizes:y,setOriginalChildrenCount:j,setChildrenCount:H,setForceUpdate:E,updateOnChange:c}},n)}));t.default=d},136:(e,t,n)=>{"use strict";n.r(t),n.d(t,{default:()=>r});const r={wrapper:"equal-height-JlocK"}},689:e=>{"use strict";e.exports=__webpack_require__(67294)}},t={};function n(r){var o=t[r];if(void 0!==o)return o.exports;var u=t[r]={exports:{}};return e[r](u,u.exports,n),u.exports}n.d=(e,t)=>{for(var r in t)n.o(t,r)&&!n.o(e,r)&&Object.defineProperty(e,r,{enumerable:!0,get:t[r]})},n.o=(e,t)=>Object.prototype.hasOwnProperty.call(e,t),n.r=e=>{"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})};var r={};(()=>{"use strict";var e=r,t=function(e){return e&&e.__esModule?e:{default:e}};Object.defineProperty(e,"__esModule",{value:!0}),e.EqualHeightConsumer=e.EqualHeightProvider=e.EqualHeightContext=e.EqualHeightElement=e.EqualHeight=void 0;var o=n(32);Object.defineProperty(e,"EqualHeight",{enumerable:!0,get:function(){return t(o).default}});var u=n(899);Object.defineProperty(e,"EqualHeightElement",{enumerable:!0,get:function(){return t(u).default}});var i=n(149);Object.defineProperty(e,"EqualHeightContext",{enumerable:!0,get:function(){return i.EqualHeightContext}}),Object.defineProperty(e,"EqualHeightProvider",{enumerable:!0,get:function(){return i.EqualHeightProvider}}),Object.defineProperty(e,"EqualHeightConsumer",{enumerable:!0,get:function(){return i.EqualHeightConsumer}})})(),module.exports=r})();

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3662,8641,5675,1664,3863,4645,5359,1559,3532,2077,8844,2883,4041,8809,9806,9774,2888,179], function() { return __webpack_exec__(74918); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);